var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: {
        btn: true,
        "btn-outline-primary": true,
        active: _vm.division.selected,
      },
      attrs: { type: "button" },
      on: {
        click: function ($event) {
          _vm.division.selected = !_vm.division.selected
        },
      },
    },
    [
      _c("p", { staticClass: "user" }, [
        _vm._v(
          "(" +
            _vm._s(_vm.division.id) +
            ") " +
            _vm._s(
              (_vm.division.user && _vm.division.user.short_name) ||
                "Не назначен"
            )
        ),
      ]),
      _vm._v(" "),
      _vm.division.cities.length
        ? _c(
            "p",
            { staticClass: "stores" },
            [
              _vm._l(_vm.division.cities, function (city, i) {
                return _c("span", [
                  _vm._v(
                    _vm._s(i !== 0 ? ", " : "") +
                      " " +
                      _vm._s(
                        city?.object_id === 0
                          ? "Почта"
                          : _vm.$AllCities[city?.object_id]?.name
                      )
                  ),
                ])
              }),
              _vm._v("\n    ("),
              _vm._l(_vm.division.stores, function (store, i) {
                return _c("span", [
                  _vm._v(
                    _vm._s(i !== 0 ? ", " : "") +
                      _vm._s(_vm.$AllStores[store?.object_id]?.short_title)
                  ),
                ])
              }),
              _vm._v(")\n  "),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }